import styled from '@emotion/styled';
import colors from '../../theme/colors';

export const NavBoxStyle = styled.div({
  height: '75px',
  background: colors.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: '20px'
});

export const FieldStyle = styled.input({
  background: colors.grayLight91,
  marginLeft: '15px',
  width: '100%',
  borderRadius: '6px',
  border: '0px',
  padding: '10px',
  color: colors.grayLight,
  fontSize: '16px',
  outline: 'none',

  '&:hover': {
    border: '1px solid #ccc'
  },

  '&:focus': {
    border: '1px solid #1976d2'
  }
});

export const AvatarBox = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  paddingTop: '22px',
  paddingBottom: '22px',
  borderBottom: `1px solid ${colors.grayLight91}`,
  marginLeft: '25px',
  marginRight: '45px',
  width: '192px',
  position: 'relative'
});

export const ToogleLogo = styled.div`
  position: absolute;
  right: -42px;
  width: 26px;
  height: 26px;
  background: ${({ theme }) => theme.primaryColor};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  rotate: ${({ isSidebarOpen }) => !isSidebarOpen && '180deg'};
`;

export const IconButtonStyle = styled.button({
  width: '44px',
  height: '44px',
  background: '#F1F1F1',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const MenuBox = styled.div({
  background: colors.white,
  height: '48px',
  borderRadius: '40px',
  display: 'flex',
  alignItems: 'center',
  padding: '4px 17px 4px 4px',
  cursor: 'pointer',
  border: '1px solid #E3E3E3'
});

export const ChipStyle = styled.div({
  height: '20px',
  background: colors.darkGreen,
  borderRadius: '10px',
  padding: '0 8px',
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  color: 'white'
});

export const ChipWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  marginLeft: '10px',
  marginRight: '17px'
});

export const Heading = styled.h2`
  font-family: 'Plus Jakarta Sans';
  font-weight: 700;
  font-size: 24px;
  margin-left: 20px;
  user-select: none;
  white-space: nowrap;
  @media (max-width: 850px) {
    font-size: 21px;
  }
`;
